// Ambient Layer — composite default export
// Mounts the one-shot BootEye intro and (when enabled) the VhsOverlay scanline layer.
// props.vhsEnabled gates the overlay the same way App's filterEnabled gates .page-filter;
// a future FloorToolbar ToolSwitch (tVhs) can flip it. Cursor module is CSS-only.
import * as React from "react";
import BootEye from "./BootEye";
import VhsOverlay from "./VhsOverlay";

function AmbientLayer(props) {
    return (
        <React.Fragment>
            <BootEye onDone={props.onBootDone} />
            {props.vhsEnabled !== false ? <VhsOverlay /> : null}
        </React.Fragment>
    );
}

export default AmbientLayer;
